//
import { Component } from "react"
import PropTypes from "prop-types"

import genericFilterGroup, { createPACTransactionsFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import { StateRegionFilter } from "shared/search/containers/Filter/Filters"

import {
    PoliticalCommitteeElectionTypeFilter,
    PoliticalCommitteeFecPartyTypeFilter,
    PoliticalCommitteeFecPartyTypeSelectFilter,
    PoliticalCommitteeOfficialFilter,
    PoliticalCommitteeOfficeFilter,
    PoliticalCommitteeCandidateNameFilter,
    PoliticalCommitteeCandidateDistrictFilter,
    PoliticalCommitteeCandidateElectionYearFilter,
    PoliticalCommitteeCandidateElectionYearSelectFilter,
    PoliticalCommitteeIsActiveFilter,
    // PoliticalCommitteeFECDesignationFilter,
    PoliticalCommitteeElectionTypeSelectFilter,
    PoliticalCommitteeCampaignFinanceReceivedMoneyFilter,
    PoliticalCommitteeCampaignFinanceDisbursedMoneyFilter,
    PoliticalCommitteeCampaignFinanceReceiptsAmountMinFilter,
    PoliticalCommitteeCampaignFinanceReceiptsAmountMaxFilter,
    PoliticalCommitteeCampaignFinanceReceiptsDateStartFilter,
    PoliticalCommitteeCampaignFinanceReceiptsDateEndFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsAmountMinFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsAmountMaxFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsDateStartFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsDateEndFilter,
    PoliticalCommitteeCampaignFinanceReceiptsContributorCommitteesFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsContributorCommitteesFilter,
    PoliticalCommitteeCampaignFinanceReceiptsLegislatorFilter,
    PoliticalCommitteeCampaignFinanceDisbursementsLegislatorFilter,
    PoliticalCommitteeImportIdFilter,
} from "shared/search/containers/Filter/PoliticalCommitteeFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export class PoliticalCommitteeFecPartyTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [PoliticalCommitteeFecPartyTypeFilter, PoliticalCommitteeFecPartyTypeSelectFilter],
        uniqueFilterGroupId: "politicalCommitteeFecPartyTypeFilterGroup",
        displayLabel: "Party",
        helpText: "Filter political committees by party. You can choose any party officially recognized by the FEC.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PoliticalCommitteeTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            PoliticalCommitteeElectionTypeFilter,
            PoliticalCommitteeElectionTypeSelectFilter,
            // TODO: add this back at some point?
            // removed in https://quorumanalytics.atlassian.net/browse/QPAC-852
            // PoliticalCommitteeFECDesignationFilter,
            PoliticalCommitteeIsActiveFilter,
        ],
        uniqueFilterGroupId: "politicalCommitteeTypeFilterGroup",
        displayLabel: "Committee Type",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const PoliticalCommitteeTransactionFilterGroup = createPACTransactionsFilterGroup({
    displayLabel: "PAC Activity",
    quorumDataType: DjangIO.app.models.QuorumDataType.political_committee,
    uniqueFilterGroupId: "politicalCommitteePACFilterGroup",
})

export const PoliticalCommitteeOfficialsFilterGroup = (props) => genericFilterGroup(props)
PoliticalCommitteeOfficialsFilterGroup.propTypes = defaultProps
PoliticalCommitteeOfficialsFilterGroup.defaultProps = {
    filters: [PoliticalCommitteeOfficialFilter],
    uniqueFilterGroupId: "politicalCommitteeOfficialsFilterGroup",
    displayLabel: "Officials",
    helpText: "Filter Results by official.",
}
export const PoliticalCommitteeCandidateFilterGroup = (props) => genericFilterGroup(props)
PoliticalCommitteeCandidateFilterGroup.propTypes = defaultProps
PoliticalCommitteeCandidateFilterGroup.defaultProps = {
    filters: [
        PoliticalCommitteeCandidateNameFilter,
        PoliticalCommitteeOfficeFilter,
        PoliticalCommitteeCandidateElectionYearFilter,
        PoliticalCommitteeCandidateElectionYearSelectFilter,
        PoliticalCommitteeCandidateDistrictFilter,
        // PoliticalCommitteeCandidateUpperLDFilter,
        // PoliticalCommitteeCandidateLowerLDFilter,
    ],
    uniqueFilterGroupId: "politicalCommitteeCandidateFilterGroup",
    displayLabel: "Candidate",
    helpText: "Filter Results by candidate.",
}

export class PoliticalCommitteeStateRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [StateRegionFilter],
        uniqueFilterGroupId: "politicalCommitteeStateRegionFilterGroup",
        displayLabel: "State/Region",
        helpText: "Filter results by a single state or a group of states.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const PoliticalCommitteeCampaignFinanceFilterGroup = (props) => genericFilterGroup(props)
PoliticalCommitteeCampaignFinanceFilterGroup.propTypes = defaultProps
PoliticalCommitteeCampaignFinanceFilterGroup.defaultProps = {
    filters: [
        // Receipts Filters
        PoliticalCommitteeCampaignFinanceReceivedMoneyFilter,
        PoliticalCommitteeCampaignFinanceReceiptsContributorCommitteesFilter,
        PoliticalCommitteeCampaignFinanceReceiptsLegislatorFilter,
        PoliticalCommitteeCampaignFinanceReceiptsAmountMinFilter,
        PoliticalCommitteeCampaignFinanceReceiptsAmountMaxFilter,
        PoliticalCommitteeCampaignFinanceReceiptsDateStartFilter,
        PoliticalCommitteeCampaignFinanceReceiptsDateEndFilter,

        // Disbursements Filters
        PoliticalCommitteeCampaignFinanceDisbursedMoneyFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsContributorCommitteesFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsLegislatorFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsAmountMinFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsAmountMaxFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsDateStartFilter,
        PoliticalCommitteeCampaignFinanceDisbursementsDateEndFilter,
    ],
    permissions: [DjangIO.app.models.PermissionType.campaign_finance],
    userPermissions: [DjangIO.app.models.PermissionType.can_access_campaign_finance],
    uniqueFilterGroupId: "politicalCommitteeCampaignFinanceFilterGroup",
    displayLabel: "Campaign Finance",
    helpText: "Filter committees by their contributions.",
}

export const PoliticalCommitteeDetailsFilterGroup = (props) => genericFilterGroup(props)
PoliticalCommitteeDetailsFilterGroup.propTypes = defaultProps
PoliticalCommitteeDetailsFilterGroup.defaultProps = {
    filters: [PoliticalCommitteeImportIdFilter],
    uniqueFilterGroupId: "politicalCommitteeDetailsFilterGroup",
    displayLabel: "Political Committee Import ID",
    helpText: "Filter Results by Import ID",
}
